import BeagleCardLibrary from 'beagle-card-library'
import React from 'react'

const BeagleCardLibraryBlock = ({message}) => {
    let data = message.config || message.content;
    let chart_config = data?.template_config?.chart_config?.find(config => config.chart_id === data?.template_config?.default_template_view?.chart_id);
    return(<div id="card-builder-container" className="card-builder-container">
        {data.template_config ? (
          <BeagleCardLibrary
            display_card_name={true}
            template={data.template_config.id}
            template_config={data.template_config}
            render_platform={'web'}
            chart_view={!(data?.template_config?.default_template_view.chart_id === 1 || 
              Object.keys(data?.template_config?.default_template_view || {}).length === 0)}
            chart_config={{
              chart_id: chart_config?.chart_id,
              chart_options: chart_config?.chart_options,
              chart_name: chart_config?.chart_name
            }}
            unique_table_data={data.unique_table_data}
            table_data={data.table_data}
            teams_filter={data.teams_filter}
          ></BeagleCardLibrary>
        ) : null}
      </div>)
}

export default BeagleCardLibraryBlock